<template>
	<div id="area_left2">
		<div class="cc-header">学生出勤分析
			<div class="title_tab">
				<div class="legend-color" style="background-color: #32ce59;"></div>应出勤
				<div class="legend-color" style="background-color: #ffb41d;margin-left: 0.1rem;"></div>实际出勤
			</div>
			<div class="view_btn" @click="showTable">未出勤明细</div>
		</div>
		<div class="main-value" id="mess_info"></div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
const echarts = require("echarts");
export default {
	data() {
		return {

		};
	},
	mounted() {
		this.initData();
		// 定时器刷新，30分钟
		let _this = this;
		this.interval = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 30);
	},
	methods: {
		showTable() {
			this.$emit("showBigEven", "学生未出勤明细", "stuAttend");
		},
		initData() {
			// 基于准备好的dom，初始化echarts实例
			let stuAttendRecordChart = echarts.init(
				document.getElementById("mess_info")
			);
			this.$http.get("/dataView/platform/getStuAttendRecord?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					var option = {
						tooltip: {
							data: ['应出勤', '实际出勤']
						},
						xAxis: {
							type: 'category',
							data: result.xData,
							boundaryGap: true,
							axisLabel: {
								interval: 0,
								rotate: 25, // 角度
								textStyle: {
									color: '#34deff',
									fontSize: fontSize(0.12)
								}
							}
						},
						grid: {
							x: 52,
							top: "12%",
							bottom: "20%",
						},
						yAxis: {
							type: 'value',
							splitLine: {
								show: true,
								lineStyle: {
									width: 1,
									color: 'rgba(255, 255, 255, 0.2)',
								}
							},
							axisLabel: {
								textStyle: {
									color: '#34deff',
									fontSize: fontSize(0.12)
								}
							},
							axisLine: {
								show: true
							}
						},
						series: [{
							name: '应出勤',
							type: 'bar',
							data: result.req_datas,
							itemStyle: {
								//柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
								normal: {
									//柱形图圆角，初始化效果
									//barBorderRadius: [20],
									color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
										offset: 0,
										color: "rgb(80, 154, 30)" // 0% 处的颜色
									}, {
										offset: 1,
										color: "rgb(106, 238, 111,0.8)" // 100% 处的颜色
									}], false)
								}
							},
							barGap: '0%',
							barWidth: 12
						},
						{
							name: '实际出勤',
							type: 'bar',
							data: result.act_datas,
							itemStyle: {
								//柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
								normal: {
									//柱形图圆角，初始化效果
									//barBorderRadius: [20],
									color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
										offset: 0,
										color: "rgb(212, 53, 13)" // 0% 处的颜色
									}, {
										offset: 1,
										color: "rgb(255, 230, 35,0.6)" // 100% 处的颜色
									}], false)
								}
							},
							barGap: '5%',
							barWidth: 12
						}
						]
					};
					stuAttendRecordChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => stuAttendRecordChart.resize(), false);
				}
			});
		}
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
	destroyed() {
		window.onresize = null;
	}
};

function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#area_left2 {
	height: 100%;

	.cc-header {
		width: 100%;
		text-align: center;
		background: url("../../assets/img/cam_titbgsmall02.png") center no-repeat;
		background-size: 100%;
		color: #34deff;
		font-size: 0.2rem;
		font-weight: bold;
		height: 0.8rem;
		line-height: 0.6rem;

		.title_tab {
			position: absolute;
			left: 0.3rem;
			top: 0.7rem;
			font-size: 0.18rem;
			height: 0.2rem;
			display: flex;
			align-items: center;

			.legend-color {
				display: inline-block;
				width: 0.25rem;
				height: 0.15rem;
				border-radius: 15%;
				margin-right: 0.05rem;
			}
		}
	}

	.main-value {
		height: 80%;
		padding-left: 1%;
	}

	.view_btn {
		position: absolute;
		right: 0.3rem;
		top: 0.6rem;
		display: inline-block;
		cursor: pointer;
		width: 1rem;
		height: 0.35rem;
		line-height: 0.35rem;
		border-radius: 0.2rem;
		background-image: linear-gradient(135deg, #15517c, #323f86);
		color: #35fff9;
		font-size: 0.15rem;
		z-index: 1;
	}
}
</style>